import {
  HomeRounded,
  ViewCarouselRounded,
  DeveloperBoardRounded,
  PermPhoneMsgRounded,
  ArtTrackRounded,
} from "@mui/icons-material";

export const pageMenu = {
  homePage: {
    id: "homePage",
    text: "Home",
    path: "/",
    icon: <HomeRounded />,
  },
  portfolioPage: {
    id: "portfolioPage",
    text: "Portfolio",
    path: "/portfolio",
    icon: <ViewCarouselRounded />,
  },
  aboutPage: {
    id: "aboutPage",
    text: "About",
    path: "/about",
    icon: <DeveloperBoardRounded />,
  },
  contactPage: {
    id: "contactPage",
    text: "Contact",
    path: "/contact",
    icon: <PermPhoneMsgRounded />,
  },
  blogPage: {
    id: "blogPage",
    text: "Blog",
    path: "/blog",
    icon: <ArtTrackRounded />,
  },
};
